/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  theme,
  Text,
  TableComponent,
  Indicator,
} from '@pfmam/pfmam';
import { Button, Table } from 'antd';
import { Box } from '../../../styles/globalStyle';
import {
  amountFormat,
  percentFormat,
  dollarToFloat,
} from '../../../utils/numberFormat';
import moment from 'moment';
import {
  colorAllocator,
  sortArrayOfObjectsInDesc,
} from '../../../utils/common';
import NoDataFound from '../../../common/components/noDataFound';
import _ from 'lodash';
const LinkButton = styled(Button)`
  padding: 0;
  display: inline-block;
  font-size: ${theme.font_size.size_xl};
  line-height: 24px;
  color: ${theme.colors.blue_primay};
  height: 24px;
  border: 0;
  background: none;
  box-shadow: none;
  padding-right: 16px;
  :hover {
    opacity: 0.6;
    color: ${theme.colors.blue_primay};
  }
  :focus,
  :active {
    opacity: 1;
    color: ${theme.colors.blue_primay};
    background: none;
  }
  .anticon + span {
    margin-left: 5px;
  }
  ${(props) =>
    props.cancel &&
    css`
      color: ${theme.colors.danger_red};
      :hover {
        opacity: 0.6;
        color: ${theme.colors.danger_red};
      }
      :focus,
      :active {
        opacity: 1;
        color: ${theme.colors.danger_red};
        background: none;
      }
    `}
`;

const ExpandButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  min-width: 32px;
  cursor: pointer;
  transition: 0.3s;
  & > span {
    height: 19px;
    min-width: 19px;
    width: 19px;
    margin: 0 auto;
    border: 2px solid ${theme.colors.grey};
    border-radius: 2px;
    padding: 5px;
    position: relative;
    transition: 0.3s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: '';
      position: absolute;
      top: 3px;
      background: ${theme.colors.black_secondary};
      height: 10px;
      width: 2px;
      transition: transform 0.3s ease-out;
      transform: rotate(0deg);
    }
    &::after {
      content: '';
      position: absolute;
      top: 7px;
      right: 2.3px;
      background: ${theme.colors.black_secondary};
      height: 2px;
      width: 10px;
      transition: transform 0.3s ease-out;
      transform: rotate(-180deg);
    }
  }
  &:focus {
    & > span {
      box-shadow: ${theme.shadows.input_focus};
      border-color: ${theme.colors.blue_primay};
    }
  }
  &.expanded {
    & > span {
      &::after {
        transform: rotate(0deg);
      }
      &::before {
        transform: rotate(90deg);
      }
    }
  }
`;

// const TableColor = (data) => {
//   data.forEach(function (elem) {
//     if (elem.name === 'Liquid') {
//       elem.color = theme.colors.anchor_blue;
//     } else if (elem.name === 'TERM') {
//       elem.color = theme.colors.pie_green;
//     } else if (elem.name === 'CD') {
//       elem.color = theme.colors.pie_yellow;
//     }
//   });
//   return data;
// };

const ProductsTable = ({ data, handleAction }) => {
  const [productsData, setProductsData] = useState([...data]);
  const columns = [
    {
      title: 'Investment',
      dataIndex: 'InvestmentTypeClassDesc',
      key: 'InvestmentTypeClassDesc',
      align: 'left',
      sorter: true,
      className: 'sort-space-none',
      width: 360,
      render: (text, record) => (
        <Box display="flex">
          <Indicator
            bgColor={record.color}
            height="12px"
            width="12px"
            rounded="20px"
            margin="6px 10px 0 0"
          />
          <Text label={text} />
        </Box>
      ),
    },
    {
      title: 'Rate',
      dataIndex: '',
      key: 'Rate',
      align: 'left',
      sorter: true,
      className: 'sort-space-none',
      width: 120,
    },
    {
      title: 'Maturity Date',
      dataIndex: '',
      key: 'MaturityDate',
      align: 'left',
      sorter: true,
      className: 'sort-space-none',
      width: '180px',
    },
    {
      title: 'Market Value',
      dataIndex: 'MarketValue',
      key: 'MarketValue',
      align: 'right',
      sorter: true,
      className: 'sort-space-none flex-end',
      render: (text) => <>{amountFormat(text)}</>,
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'right',
      width: 140,
    },
  ];
  const getChildColumns = (InvestmentTypeClassDesc) => {
    const childColumns = [
      {
        title: '',
        dataIndex: 'blank_cell',
        key: 'blank_cell',
        align: 'left',
        sorter: true,
        width: 65,
      },
      {
        title: '',
        dataIndex: 'Description',
        key: 'Description',
        align: 'left',
        sorter: true,
        className: 'sort-space-none',
        render: (text) => <Text label={text} />,
        width: 360,
      },
      {
        title: '',
        dataIndex: 'Rate',
        key: 'Rate',
        align: 'left',
        sorter: true,
        className: 'sort-space-none',
        render: (text) => (
          <>
            {text != null ? (
              <Box
                display="inline-block"
                boxcolor={`${theme.colors.green_light}`}
                padding="2px 8px"
                radius="2px"
              >
                <Text
                  label={text != null ? percentFormat(text) : null}
                  fontSize={`${theme.font_size.size_l}`}
                  lineheight="20px"
                />
              </Box>
            ) : null}
          </>
        ),
        width: 120,
      },
      {
        title: '',
        dataIndex: 'MaturityDate',
        key: 'MaturityDate',
        align: 'left',
        //sorter: true,
        className: 'sort-space-none',
        width: '180px',
        render: (text) =>
          text ? <Text label={moment(text).format('MMM DD, YYYY')} /> : null,
      },
      {
        title: '',
        dataIndex: 'MarketValue',
        key: 'MarketValue',
        align: 'right',
        // sorter: true,
        className: 'sort-space-none flex-end',
        render: (text) => <>{amountFormat(text)}</>,
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        align: 'right',
        width: 140,
        render: (_, record) => (
          <>
            {InvestmentTypeClassDesc !== 'Liquid' && (
              <LinkButton
                type="link"
                onClick={() => {
                  handleAction(record, 'investment');
                }}
              >
                Details
              </LinkButton>
            )}
          </>
        ),
      },
    ];
    return childColumns;
  };

  const expandable = {
    defaultExpandAllRows: false,
    expandedRowRender: (childRecord) => (
      <Table
        showHeader={false}
        columns={getChildColumns(childRecord.InvestmentTypeClassDesc)}
        dataSource={childRecord.Holdings}
        pagination={false}
        onRow={(record) =>
          childRecord.InvestmentTypeClassDesc !== 'Liquid' && {
            onClick: () => {
              handleAction(record, 'investment');
            },
          }
        }
      />
    ),
    expandIcon: ({ expanded, onExpand, record }) => (
      <ExpandButton
        className={expanded ? 'expanded' : ''}
        onClick={(e) => {
          e.stopPropagation();
          onExpand(record, e);
        }}
      >
        <span></span>
      </ExpandButton>
    ),
  };

  function onChange(pagination, filters, sorter) {
    if (sorter && data) {
      if (sorter.order) {
        const order = sorter.order === 'ascend' ? 'asc' : 'desc';
        const productTypes = [...data];
        productTypes.map((productType, index) => {
          let sortedData;
          if (sorter.columnKey === 'MaturityDate') {
            sortedData = _.orderBy(
              productType.Holdings,
              function (o) {
                return new moment(o.MaturityDate);
              },
              [order]
            );
          } else {
            sortedData = _.orderBy(
              productType.Holdings,
              [sorter.columnKey],
              [order]
            );
          }

          productTypes[index].Holdings = [...sortedData];
        });
        setProductsData([...productTypes]);
      } else {
        setProductsData([...data]);
      }
    }
  }
  return (
    <TableComponent
      className="table-primary"
      title={
        <Box
          display="flex"
          justifycontent="space-between"
          alignitems="center"
          padding="24px 16px 24px 32px"
          border={`1px solid ${theme.colors.grey_fossil}`}
          borderwidth="0 0 1px 0"
        >
          <Text
            label="Investment Types"
            fontSize={`${theme.font_size.size_3xl}`}
            lineheight="32px"
            color={`${theme.colors.black_tertiary}`}
          />
        </Box>
      }
      columns={columns}
      dataSource={sortArrayOfObjectsInDesc(data, 'MarketValue')}
      locale={{
        emptyText: (
          <NoDataFound text="No available investments" padding="18px 16px" />
        ),
      }}
      showSorterTooltip={false}
      pagination={
        data.length > 10
          ? {
              position: ['bottomRight'],
              showQuickJumper: true,
              size: 'default',
            }
          : false
      }
      expandable={expandable}
      onChange={onChange}
    />
  );
};

export default ProductsTable;
